import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import CustomColumnMenu from "../../components/DataGridCustomColumnMenu";
import SendIcon from "@mui/icons-material/Send";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { api, useGetEventQuery, usePostUpdateStatusMutation } from "../../state/api";
import { deleteEventAction } from "../../redux/actions/eventAction";
// import { NotificationAddSharp } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import axios from "axios";

const Event = () => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sort, setSort] = useState({});
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const { data, error, isLoading } = useGetEventQuery({
    page,
    pageSize,
    sort: JSON.stringify(sort),
    search,
  });
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [isEventDataFetched, setIsEventDataFetched] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [users, setUsers] = useState([]);
  const [events, setEvents] = useState([]);
  const [dates, setDates] = useState({ fromDate: "", toDate: "" });
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const uniqueLocations = [...new Set(events.map((event) => event.location))];

  useEffect(() => {
    if (data) {
      setRowData(data);
    }
  }, [data]);

  const handleEdit = async (eventId) => {
    try {
      navigate(`/event/edit/${eventId}`);
    } catch (error) {
      console.log("Error navigating to edit", error);
      toast.error("Error navigating to edit");
    }
  };

  const handleDelete = async (_id) => {
    try {
      const success = await dispatch(deleteEventAction(_id));
      if (success) {
        toast.success("Event deleted successfully");
        dispatch(api.util.invalidateTags(["Event"]));
      } else {
        toast.error("Failed to delete Event");
      }
    } catch (error) {
      console.error("Error Deleting Event:", error);
    }
  };

  const navigate = useNavigate();

  const navigateCreate = () => {
    navigate("/event/create");
  };

  const [updateStatus] = usePostUpdateStatusMutation();

  const handleStatus = async (Id, isActive) => {
    const tag = "Event";
    try {
      const response = await updateStatus({ Id, tag, isActive });
      // console.log(response);
      if (response.data.success) {
        setRowData((prevData) =>
          prevData.map((row) =>
            row._id === Id ? { ...row, isActive: !isActive } : row
          )
        );
        toast.success("Status updated successfully");
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [selectedUserList, setSelectedUserList] = useState([]);

  const showUsers = async (eventId) => {
    try {
      const response = await axios.get(
        `/event/eventUserList?eventId=${eventId}`
      );
      console.log("API Response:", response); // Debugging log
      setSelectedUserList(response.data);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  // const handleNotifyEvent = async () => {
  //   try {
  //     const response = await axios.post("/fcm/notification/send");
  //     console.log("Event Notification sent:", response.data);
  //   } catch (error) {
  //     console.error("Error sending event notification:", error);
  //   }
  // };

  const removeEvent = (_id) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(_id);
      }
    });
  };

  let [filterData, setFilterData] = useState({});

  const fetchData = async () => {
    try {
      const response = await axios.get("/user/userFullname");
      setUsers(response.data.profile);
      setIsDataFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleOpen = () => {
    if (!isDataFetched) {
      fetchData();
    }
  };

  const eventData = async () => {
    try {
      const response = await axios.get("/event/eventNameList");
      setEvents(response.data);
      setIsEventDataFetched(true);
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  };

  const handleEventOpen = () => {
    if (!isEventDataFetched) {
      eventData();
    }
  };

  const handleChange = (event, type) => {
    const value = event.target.value;
    if (value === "all") {
      setDates({ fromDate: "", toDate: "" });
      setFilterData({});
    } else {
      if (type === "fromDate" || type === "toDate") {
        setDates((prevDates) => ({
          ...prevDates,
          [type]: value,
        }));
        setFilterData((prevFilters) => ({
          ...prevFilters,
          [type]: value,
        }));
      } else {
        setFilterData((prevFilters) => ({
          ...prevFilters,
          [type]: value,
        }));
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const params = {
        ...filterData,
      };
      if (dates.fromDate) params.fromDate = dates.fromDate;
      if (dates.toDate) params.toDate = dates.toDate;

      const response = await axios.get("/event/list", { params });
      setRowData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      field: "eventName",
      headerName: "Event-Name",
      flex: 0.5,
    },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 0.5,
    },
    {
      field: "endTime",
      headerName: "End Time",
      flex: 0.5,
    },
    {
      field: "isActive",
      headerName: "IsActive?",
      flex: 0.5,
      renderCell: (params) => (
        <div>
          <Switch
            checked={params.value}
            onChange={() => handleStatus(params.row._id, params.row.isActive)}
            inputProps={{ "aria-label": "toggle status" }}
            color="default"
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "green",
                "&:hover": {
                  backgroundColor: "rgba(0, 128, 0, 0.50)",
                },
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "green",
              },
              "& .MuiSwitch-switchBase": {
                color: "red",
                "&:hover": {
                  backgroundColor: "rgba(255, 0, 0, 0.5)",
                },
              },
              "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                backgroundColor: "red",
              },
            }}
          />
          {params.value ? "T" : "F"}
        </div>
      ),
    },
    {
      field: "location",
      headerName: "Location",
      flex: 0.5,
      // renderCell: (params) => {
      //   return params.value.replace(/^(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");
      // },
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "updatedAt",
      headerName: "UpdatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      flex: 0.6,
      renderCell: (params) => (
        <div>
          <IconButton
            // variant="contained"
            color="info"
            onClick={() => handleEdit(params.row._id)}
          >
            <EditIcon size="large" />
          </IconButton>
          <IconButton
            variant="contained"
            color="light"
            onClick={() => showUsers(params.row._id)}
          >
            <AccountCircleIcon />
          </IconButton>
          {/* <IconButton
            color="info"
            onClick={() => handleSendNotification(params.row._id)}
            onChange={(e) => setFcmToken(e.target.value)}
            label="FCM Token"
            value={fcmToken}
          >
            <NotificationAddSharp size="small" />
          </IconButton> */}
          <IconButton
            // variant="contained"
            color="secondary"
            onClick={() => removeEvent(params.row._id)}
          >
            <DeleteIcon size="small" sx={{ color: "red" }} />
          </IconButton>
        </div>
      ),
    },
  ];
  return (
    <Box m="1.5rem 2.5rem">
      <ToastContainer />
      <Header title="EVENT MANAGEMENT" />
      <Box display="flex" flexWrap="wrap" alignItems="flex-end">
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">User</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "userId")}
            onOpen={handleOpen}
            label="User"
          >
            <MenuItem value="all">All</MenuItem>
            {isDataFetched &&
              users.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.fullname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">Event Name</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "eventName")}
            onOpen={handleEventOpen}
            label="Event Name"
          >
            <MenuItem value="all">All</MenuItem>
            {isEventDataFetched &&
              events.map((event) => (
                <MenuItem key={event.eventName} value={event.eventName}>
                  {event.eventName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">Location</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "location")}
            onOpen={handleEventOpen}
            label="Location"
          >
            <MenuItem value="all">All</MenuItem>
            {isEventDataFetched &&
              uniqueLocations.map((location) => (
                <MenuItem key={location} value={location}>
                  {location}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <div>
            <TextField
              id="from-date"
              label="From"
              type="date"
              value={dates.fromDate}
              onChange={(e) => handleChange(e, "fromDate")}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="to-date"
              label="To"
              type="date"
              value={dates.toDate}
              onChange={(e) => handleChange(e, "toDate")}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ marginLeft: 2 }}
            />
          </div>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 100 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SendIcon />}
            onClick={handleSubmit}
          >
            Filter
          </Button>
        </FormControl>
        <Button
          variant="contained"
          endIcon={<AddCircleIcon />}
          onClick={navigateCreate}
          sx={{ m: 2, ml: "auto" }}
        >
          Add Event
        </Button>
      </Box>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.success,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={rowData ? rowData : []}
          columns={columns}
          autoHeight
          disableColumnMenu
          disableColumnSelector
          hideFooter
          // initialState={{
          //   pinnedColumns: { right: ["actions"] },
          // }}
          rowCount={(rowData && rowData.total) || 0}
          rowsPerPageOptions={[20, 50, 100]}
          pagination
          page={page}
          pageSize={pageSize}
          paginationMode="server"
          sortingMode="server"
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSortModelChange={(newSortModel) => setSort(...newSortModel)}
        />
      </Box>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ fontWeight: "bold" }}>User List</DialogTitle>
        <DialogContent>
          {selectedUserList &&
          selectedUserList.users &&
          selectedUserList.users.length > 0 ? (
            <List>
              {selectedUserList.users.map((user) => (
                <ListItem key={user._id}>
                  <ListItemText primary={user.fullname} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography>No user has attended event yet.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default Event;
